"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkProfileTracker = exports.isProfileTracker = void 0;
const __1 = require("..");
function isProfileTracker(object) {
    return checkProfileTracker(object).fulfilled;
}
exports.isProfileTracker = isProfileTracker;
function checkProfileTracker(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return (0, __1.check)(object, (0, __1.hasString)("name"), (0, __1.hasChoice)("type", ["register", "last"]), (0, __1.hasChoice)("provider", ["adjust", "web", "transactional"])).withOptions(options).explain();
}
exports.checkProfileTracker = checkProfileTracker;
//# sourceMappingURL=ProfileTracker.js.map